import {
  GET_BILLS,
  CLEAR_BILLS_LIST,
  GET_PROVIDER_BILLS,
  GET_BILL_BY_ID
} from "../constants/constants";

const initialSessionState = { bills: [], bill: {} };

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_BILLS:
      return {
        ...state,
        bills: [...action.bills.content],
        totalElements: action.bills.totalElements
      };
    case GET_PROVIDER_BILLS:
      return {
        ...state,
        bills: [...action.bills.content],
        totalElements: action.bills.totalElements
      };
      case GET_BILL_BY_ID:
      return {
        ...state,
        bill: {...action.bills}
      };
    case CLEAR_BILLS_LIST:
      return {
        ...state,
        bills: [],
        totalElements: 0
      };
    default: return state;
  }

};

export const getBills = state => state.billReducer.bills;
export const getTotalElements = state => state.billReducer.totalElements;
export const getProviderBills = state => state.billReducer.bills;
export const getBillById = state => state.billReducer.bill;
